<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>基地管理</el-breadcrumb-item>
        <el-breadcrumb-item>基地列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="基地名称：">
              <el-select clearable style="width: 100%" size="small" v-model="listParams.farmId" placeholder="请选择基地">
                <el-option v-for="item in baseNameList" :label="item.title" :value="item.id" :key="item.id"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" type="primary" size="small" @click="toCreate"> 新增 </el-button>

          <el-button class="align-left" type="success" size="small" @click="maintainData"> 生产数据维护 </el-button>

          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" border>
        <el-table-column align="center" width="60" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column prop="title" align="center" label="基地名称"> </el-table-column>

        <el-table-column prop="address" align="center" label="基地地址"> </el-table-column>

        <el-table-column prop="sort" align="center" label="排序"> </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteItem(scope.row.farmId)">
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog class="hx-to-create-template" :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="resetDialogForm" :close-on-click-modal="false">
      <div>
        <el-form ref="dialogForm" :model="itemParams" :rules="checkItemParams" label-width="120px">
          <el-form-item label="基地名称 ：" prop="title">
            <el-input v-model="itemParams.title" size="small" placeholder="请输入基地名称"> </el-input>
          </el-form-item>

          <el-form-item label="基地地址 ：" prop="address">
            <el-input v-model="itemParams.address" size="small" placeholder="请输入基地地址"> </el-input>
          </el-form-item>

          <el-form-item label="序号：" prop="sort">
            <el-input-number size="small" v-model="itemParams.sort" :min="1" label="描述文字"></el-input-number>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary" @click="saveItem('dialogForm')" :disabled="isDisabled"> 保 存 </el-button>

            <el-button size="small" @click="dialogVisible = false"> 取 消 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        farmId: "",
        supplyId: "",
      },
      baseNameList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      dialogTitle: "",
      dialogVisible: false,
      isDisabled: false,
      method: "",
      url: "",
      itemParams: {
        title: "",
        address: "",
        sort: 1,
        supplyId: "",
      },
      checkItemParams: {
        title: [{ required: true, message: "请输入基地名称", trigger: "blur" }],
        address: [{ required: true, message: "请输入基地名称", trigger: "blur" }],
        sort: [{ required: true, message: "请输入序号", trigger: "change" }],
      },
    };
  },
  mounted() {
    this.listParams.supplyId = this.$route.params.supplyId;
    this.loadBaseNameList();
    this.loadTableData();
  },
  methods: {
    /**
     * 初始化基地名称列表
     */
    loadBaseNameList() {
      this.$http({
        url: global.apiUrl + "/farm/title",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.baseNameList = res.body.data.dataList;
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/farm/farm-index",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
          farmId: this.listParams.farmId,
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 新增基地列表
     */
    toCreate() {
      this.dialogVisible = true;
      this.dialogTitle = "新增基地列表";
      this.method = "POST";
      this.url = global.apiUrl + "/farm/insert";
      if (this.itemParams.id) {
        delete this.itemParams.id;
      }
    },
    /**
     * 生产数据维护
     */
    maintainData() {
      this.$router.push({
        name: "maintainData",
      });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 编辑数据条目
     * @param row
     */
    editItem(row) {
      this.dialogVisible = true;
      this.dialogTitle = "编辑基地列表";
      this.method = "PUT";
      this.url = global.apiUrl + "/farm/change";
      Object.assign(this.itemParams, row);
    },
    /**
     * 删除数据条目
     * @param farmId
     */
    deleteItem(farmId) {
      this.$http({
        url: global.apiUrl + "/farm/delete?farmId=" + farmId,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 保存新增或修改
     * @param name
     */
    saveItem(name) {
      this.isDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$http({
            url: this.url,
            method: this.method,
            body: this.itemParams,
          }).then(res => {
            if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
              this.dialogVisible = false;
              this.isDisabled = false;
              this.$message.success(res.body.info);
              this.loadTableData();
            } else {
              this.isDisabled = false;
            }
          });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.itemParams.supplyId = parseInt(vm.$route.params.supplyId);
    });
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
